module.exports = __webpack_public_path__ + "img/3-3.3aca41d3.jpeg";